import { PlayerSizesTypes } from '../../../common/store/store.types';
import { flexRowBetween, flexRowEnd } from '../../../common/styles/flex';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { isEmpty } from '../../../common/utils/utils';
import { removeHighlights } from '../styles';
import { CTA_BUTTON_HEIGHT, TOP_BAR_HEIGHTS } from '../controlsPlugin.constants';

interface StylesObject {
  topBarContainerStyle: { [key: string]: any };
}

const getTopBarContainerStyle = (showStoriesSeekBars: boolean, showCTA: boolean) => {
  const mediumSizeWithStories = showCTA ? CTA_BUTTON_HEIGHT.MEDIUM : 'auto';
  const largeSizeWithStories = showCTA ? CTA_BUTTON_HEIGHT.LARGE_AND_EXTRA_LARGE : 'auto';
  const mediumSizeHideWithStories = showCTA ? `translateY(-${CTA_BUTTON_HEIGHT.MEDIUM})` : 'auto';
  const largeSizeHideWithStories = showCTA ? `translateY(-${CTA_BUTTON_HEIGHT.LARGE_AND_EXTRA_LARGE})` : 'auto';
  return ({
    ...flexRowBetween,
    ...removeHighlights,
    alignItems: 'center',
    width: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    transition: 'all 0.5s ease-in-out',
    opacity: 1,
    transform: 'translateY(0)',
    withBackground: {
      backgroundImage: SITE_VARIABLES.COLORS.GRADIENT_BLACK,
    },
    small: {
      backgroundImage: 'inherit',
      height: TOP_BAR_HEIGHTS.SMALL,
    },
    medium: {
      height: showStoriesSeekBars ? mediumSizeWithStories : TOP_BAR_HEIGHTS.MEDIUM,
    },
    large: {
      height: showStoriesSeekBars ? largeSizeWithStories : TOP_BAR_HEIGHTS.LARGE,
    },
    extraLarge: {
      height: showStoriesSeekBars ? largeSizeWithStories : TOP_BAR_HEIGHTS.EXTRA_LARGE,
    },
    adControls: {
      ...flexRowEnd,
      display: 'none',
    },
    hide: {
      opacity: 0,
      small: {
        transform: `translateY(-${TOP_BAR_HEIGHTS.SMALL})`,
      },
      medium: {
        transform: showStoriesSeekBars ? mediumSizeHideWithStories : `translateY(-${TOP_BAR_HEIGHTS.MEDIUM})`,
      },
      large: {
        transform: showStoriesSeekBars ? largeSizeHideWithStories : `translateY(-${TOP_BAR_HEIGHTS.LARGE})`,
      },
      extraLarge: {
        transform: showStoriesSeekBars ? largeSizeHideWithStories : `translateY(-${TOP_BAR_HEIGHTS.EXTRA_LARGE})`,
      },
      recirculationControls: {
        transform: 'unset',
      },
    },
  });
};

export const getTopBarStyleObject = (isVisible: boolean, isTitle: boolean, playerSize: PlayerSizesTypes, showAdControls: boolean, splitViewRatio: number, showCloseBar: boolean, showStoriesSeekBars: boolean, showCTA: boolean): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  const splitView = !isEmpty(splitViewRatio);
  const topBarContainer = getTopBarContainerStyle(showStoriesSeekBars, showCTA);

  return ({
    topBarContainerStyle: [
      topBarContainer,
      isTitle && !splitView && !showCloseBar && !showStoriesSeekBars && topBarContainer.withBackground,
      showAdControls && topBarContainer.adControls,
      smallSize && topBarContainer.small,
      mediumSize && topBarContainer.medium,
      largeSize && topBarContainer.large,
      extraLargeSize && topBarContainer.extraLarge,
      !isVisible && topBarContainer.hide,
      !isVisible && smallSize && topBarContainer.hide.small,
      !isVisible && mediumSize && topBarContainer.hide.medium,
      !isVisible && largeSize && topBarContainer.hide.large,
      !isVisible && extraLargeSize && topBarContainer.hide.extraLarge,
      !isVisible && showStoriesSeekBars && topBarContainer.hide.recirculationControls,
    ],
  });
};
